import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { motion } from "framer-motion";

const PageNotFound = () => {
  const logo_404 = 'Assets/Images/404.svg'
  const droneImage = "Assets/Images/Pagenotfound/drone-pagenotfound.svg"; 
  const droneImageLeft = "Assets/Images/Pagenotfound/cloudleft.svg"; 
  const droneImageRight = "Assets/Images/Pagenotfound/cloudright.svg"; 
  const lightimage = "Assets/Images/Pagenotfound/lightimage.svg"; 
  const logo404 = "Assets/Images/Pagenotfound/image404.svg"; 

  const [showSecond, setShowSecond] = useState(false);
  const [show404, setShow404] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "70vh",
        height: "auto",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        px: { xs: 2, sm: 3, md: 4 }, // Responsive horizontal padding
        pt: { xs: 2.5, sm: 5, md: 7.5 }, // Responsive top padding (20px, 40px, 60px)
        mt: { xs: 2, sm: 3.75, md: 5 }, // Responsive top margin (16px, 30px, 40px)
      }}
    >
      {/* Animated drone */}
      <motion.img
        src={droneImage}
        alt="Flying Drone"
        initial={{ y: "-100vh", opacity: 0 }}
        animate={{ y: 10, opacity: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        onAnimationComplete={() => setShowSecond(true)}
        style={{
          width: "min(300px, 60vw)", // Responsive width with max 300px
          height: "auto",
          maxWidth: "100%",
        }}
      />
      
      {showSecond && (
        <motion.img
          src={lightimage}
          alt="Light Image"
          initial={{ scaleY: 0, opacity: 0 }}
          animate={{ scaleY: 1, opacity: 1 }}
          transition={{ duration: 1 }}
          onAnimationComplete={() => setShow404(true)}
          style={{
            height: "min(400px, 40vh)", // Responsive height
            width: "auto",
            maxWidth: "80vw", // Prevent overflow on small screens
          }}
        />
      )}
      
      {show404 && (
        <Box 
          sx={{ 
            position: "relative", 
            width: { xs: "250px", sm: "300px" }, // Responsive width
            height: { xs: "80px", sm: "100px" }, // Responsive height
            mt: 2
          }}
        >
          {/* Oval Background */}
          <Box
            sx={{
              position: "absolute",
              top: "0%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "270px", sm: "320px" }, // Responsive oval
              height: { xs: "70px", sm: "90px" },
              bgcolor: "rgba(255,165,0,0.1)",
              borderRadius: "50%",
              zIndex: 0,
            }}
          />
          {/* 404 Image */}
          <Box
            component="img"
            src={logo404}
            alt="404"
            sx={{
              position: "relative",
              zIndex: 1,
              width: "100%",
              height: "auto",
            }}
          />
        </Box>
      )}
      
      {/* Cloud container */}
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: "10%", sm: "15%", md: "20%" }, // Responsive bottom position
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 1, sm: 2, md: 4 }, // Responsive gap
          pointerEvents: "none",
          width: "100%",
          maxWidth: "100vw",
        }}
      >
        {/* Left floating cloud */}
        <motion.img
          src={droneImageLeft}
          alt="Floating Cloud Left"
          animate={{
            x: [0, -10, 0, 10, 0],
          }}
          transition={{
            x: { duration: 6, repeat: Infinity, ease: "easeInOut" },
          }}
          style={{
            width: "min(350px, 35vw)", // Responsive cloud size
            opacity: 0.8,
            maxWidth: "100%",
          }}
        />

        {/* Right floating cloud */}
        <motion.img
          src={droneImageRight}
          alt="Floating Cloud Right"
          animate={{
            x: [0, 10, 0, -10, 0],
          }}
          transition={{
            x: { duration: 7, repeat: Infinity, ease: "easeInOut" }
          }}
          style={{
            width: "min(350px, 35vw)", // Responsive cloud size
            opacity: 0.8,
            maxWidth: "100%",
          }}
        />
      </Box>
    </Box>
  );
};

export default PageNotFound;